import service from '@/store/services/vendors/labourers-service';

const state = {
    list: [],
    terminated: [],
    labourer: {},
    meta: {},
    statistics: {},
    syncBiotimeAreas: {},
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_TERMINATED: (state, terminated) => {
        state.terminated = terminated || [];
    },
    SET_RESOURCE: (state, labourer) => {
        state.labourer = labourer;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_URL: (state, url) => {
        state.url = url;
    },
    SET_STATISTICS: (state, statistics) => {
        state.statistics = statistics;
    },
    UPDATE_LABOURER_STATUS(state, updatedLabourer) {

        // update selected labourer
        if (
            state.labourer &&
            state.labourer.id === updatedLabourer.id
        ) {

            state.labourer = {
                ...updatedLabourer
            };
        }

        // ensure list is array
        if (!Array.isArray(state.list)) {
            return;
        }

        const index = state.list.findIndex(
            labourer => labourer.id === updatedLabourer.id
        );

        if (index !== -1) {

            // Vue reactivity safe
            state.list.splice(index, 1, {
                ...state.list[index],
                ...updatedLabourer
            });
        }
    }
    // UPDATE_LABOURER_STATUS(state, updatedLabourer) {
    //
    //     // current resource
    //     if (
    //         state.labourer &&
    //         state.labourer.id === updatedLabourer.id
    //     ) {
    //
    //         state.labourer = updatedLabourer;
    //     }
    //
    //     // ensure array exists
    //     if (!Array.isArray(state.list)) {
    //         return;
    //     }
    //
    //     const index = state.list.findIndex(
    //         labourer => labourer.id === updatedLabourer.id
    //     );
    //
    //     if (index !== -1) {
    //
    //         state.list.splice(
    //             index,
    //             1,
    //             updatedLabourer
    //         );
    //     }
    // },
    // UPDATE_LABOURER_STATUS(state, updatedLabourer) {
    //
    //     // Update current labourer
    //     if (
    //         state.labourer &&
    //         state.labourer.id === updatedLabourer.id
    //     ) {
    //
    //         state.labourer = updatedLabourer;
    //     }
    //
    //     // Update list item
    //     const index = state.list.findIndex(
    //         labourer => labourer.id === updatedLabourer.id
    //     );
    //
    //     if (index !== -1) {
    //
    //         state.list.splice(
    //             index,
    //             1,
    //             updatedLabourer
    //         );
    //     }
    // },
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    // terminated ({ commit, dispatch }, params = {}) {
    //     return service.terminated(params)
    //         .then(({ terminated, meta }) => {
    //             commit('SET_TERMINATED', terminated);
    //             commit('SET_META', meta);
    //         });
    // },
    terminated ({ commit }, params = {}) {
        return service.terminated(params)
            .then(({ terminated, meta }) => {

                commit('SET_TERMINATED', terminated);
                commit('SET_META', meta);
            });
    },


    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(labourer => {
                commit('SET_RESOURCE', labourer);
            });
    },

    view ({ commit, dispatch }, params) {
        return service.view(params)
            .then(labourer => {
                commit('SET_RESOURCE', labourer);
            });
    },

    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(labourer => {
                commit('SET_RESOURCE', labourer);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((labourer) => {
                commit('SET_RESOURCE', labourer);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((labourer) => {
                commit('SET_RESOURCE', labourer);
            });
    },
    syncPunch ({ commit, dispatch }, params) {
        return service.syncPunch(params)
            .then((labourer) => {
                commit('SET_RESOURCE', labourer);
            });
    },
    upload ({ commit, dispatch }, { labourer, image }) {
        return service.upload(labourer, image)
            .then((url) => {
                commit('SET_URL', url);
            });
    },
    downloadTemplate() {
        return service.downloadTemplate();
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
    statusStatistics ({ commit, dispatch }, params) {
        return service.getStatusStatistics(params)
            .then((statistics) => {
                commit('SET_STATISTICS', statistics);
            });
    },

    // async updateStatus({ commit }, payload) {
    //
    //     const response =
    //         await service.updateStatus(payload);
    //
    //     commit(
    //         'UPDATE_LABOURER_STATUS',
    //         response.data
    //     );
    //
    //     return response;
    // },
    async updateStatus({ commit }, payload) {

        const labourer =
            await service.updateStatus(payload);

        commit(
            'UPDATE_LABOURER_STATUS',
            labourer
        );

        return labourer;
    },
    // async activateToVendor({ dispatch }, id) {
    //     try {
    //         const response = await service.activateToVendor(id);
    //
    //         // optional: refresh list after update
    //         await dispatch('terminated');
    //
    //         return response;
    //     } catch (error) {
    //         throw error;
    //     }
    // },
    async activateToVendor({ commit }, payload) {

        const response =
            await service.activateToVendor(
                payload.id,
                payload.data
            );

        if (response.data) {

            commit(
                'UPDATE_LABOURER_STATUS',
                response.data
            );
        }

        return response;
    },

    async fetchReadiness({ commit }, params) {
        return service.fetchReadiness(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    async syncBiotime({ commit }, id) {
        return service.syncBiotime(id)
            .then(labourer => {
                commit('SET_RESOURCE', labourer);
            });
    },
    registrationBiotime({ commit }, params) {
        commit('SET_LOADING', true);
        return service.registrationBiotime(params)
            .then(labourer => {
                commit('SET_RESOURCE', labourer);
                commit('SET_LOADING', false);
                return labourer;
            })
            .catch(error => {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    async syncBiotimeAreas({ commit }, payload) {
        // try {
        return await service.syncBiotimeAreas(payload)
        // } catch (error) {
        //     throw error;
        // }
    }
};

const getters = {
    list: state => state.list,
    terminated: state => state.terminated,
    url: state => state.url,
    listTotal: state => state.meta.page.total,
    listMeta: state => state.meta,
    labourer: state => state.labourer,
    statistics: state => state.statistics,
    dropdown: (state) => {
        return state.list.map(labourer => ({
            id: labourer.id,
            first_name: labourer.first_name,
            last_name: labourer.last_name,
            middle_name: labourer.middle_name
        }));
    }
};

const labourers = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default labourers;
